import Bugsnag, { type NotifiableError } from '@bugsnag/js';

import { isExpectedNetworkAxiosError } from './isExpectedNetworkAxiosError';

const isExpectedNetworkFailure = (arg: unknown) =>
  isExpectedNetworkAxiosError(arg) ||
  (typeof arg === 'object' &&
    arg !== null &&
    'error' in arg &&
    isExpectedNetworkAxiosError(arg.error));

const logForce = (...args: unknown[]) => {
  // eslint-disable-next-line no-console
  console.log(...args);
};

const logError = (...args: unknown[]) => {
  console.error(...args);

  if (process.env.NEXT_PUBLIC_BUGSNAG_ENABLED) {
    if (args.some(isExpectedNetworkFailure)) return;

    const [error] = args;
    Bugsnag.notify(error as NotifiableError, (event) => {
      if (typeof error === 'string') event.groupingHash = error;
    });
  }
};

const logWarn = (...args: unknown[]) => {
  if (process.env.NEXT_PUBLIC_DEBUG !== 'true') return;
  console.warn(...args);
};

const log = (...args: unknown[]) => {
  if (process.env.NEXT_PUBLIC_DEBUG !== 'true') return;

  logForce(...args);
};

export default log;

export { logError, logWarn };
